export const systemEmailsList = getters => {
  return getters.systemEmailsList
}

export const getManagingSystemEmail = getters => {
  return getters.manageSystemEmail
}
